import React from "react";
import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
} from "react-icons/md";

// Admin Imports
import Enterprise from "views/admin/enterprise";
import Dashbaord from "views/admin/dashboard";
import Profile from "views/admin/profile";
import Team from "views/admin/team";

// Auth Imports
import SignInCentered from "views/auth/signIn";

const routes = [
  {
    name: "Tableau de Pilotage",
    layout: "",
    path: "/",
    icon: (
      <Icon
        as={MdBarChart}
        width='20px'
        height='20px'
        color='#51E68B'
      />
    ),
    component: Dashbaord,
    secondary: true,
  },
  {
    name: "Mon Entreprise",
    layout: "",
    path: "/entreprise",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: Enterprise,
  },
  {
    name: "Mes Équipes",
    layout: "",
    path: "/equipes",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: Team,
  },
  {
    name: "Mon Espace RH",
    layout: "",
    path: "/profile",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: Profile,
  },
  {
    name: "Sign In",
    layout: "",
    path: "/login",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: SignInCentered,
  }
];

export default routes;
